<script lang="ts" setup>
import type { SbBlogAtAGlanceStoryblok } from '@/types'

interface Props {
  blok: SbBlogAtAGlanceStoryblok
}

const props = defineProps<Props>()

const list = ref<HTMLElement[]>()
onMounted(() => {
  const allBlogPostElements = document
    .getElementsByClassName('blogpost__content')[0]
    .getElementsByTagName('*')

  list.value = Array.from(allBlogPostElements as HTMLCollectionOf<HTMLElement>)
    .filter((item) => item.tagName.match(/H2|H3/))
    .filter((item) => item.id !== '')
})
</script>

<template>
  <div class="at-a-glance">
    <p class="at-a-glance__heading heading--4">At a glance:</p>
    <ul class="at-a-glance__list">
      <li
        v-for="(item, index) in list"
        :key="index"
        :class="[
          item.tagName === 'H3' ? 'at-a-glance__item-h3' : 'at-a-glance__item',
          {
            'at-a-glance__item--numbered': blok.use_numbers,
          },
        ]"
      >
        <nuxt-link
          :to="{ hash: `#${item.getAttribute('id')}` }"
          class="at-a-glance__link"
        >
          {{ item.innerText }}
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.at-a-glance {
  counter-reset: item;
  margin: var(--space64) 0;

  &__heading {
    margin-bottom: 24px;
  }

  &__item {
    margin-bottom: 8px;
    display: flex;

    &::before {
      position: relative;
      bottom: 2px;
      color: var(--color-link);
      content: '•';
      margin-right: 8px;
      width: 16px;
    }

    &--numbered {
      &::before {
        content: counter(item) '.';
        counter-increment: item;
        margin-right: 8px;
        bottom: 0;
      }
    }
  }

  &__item-h3 {
    margin-bottom: 8px;

    &::before {
      position: relative;
      bottom: 2px;
      color: var(--color-link);
      content: '◦';
      margin-right: 13px;
      margin-left: 24px;
    }
  }

  &__link {
    color: var(--color-link);

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
